import { z } from 'zod';
import { ExternalPaymentType } from '@mews-commander/data-access';
import { CommonProcessPaymentFormSchema, ProcessPaymentFormField } from '../ProcessPaymentFormSchema';

export enum ExternalPaymentFormField {
    Type = 'type',
    ExternalIdentifier = 'externalIdentifier',
}

export const externalPaymentFormSchema = CommonProcessPaymentFormSchema.extend({
    [ProcessPaymentFormField.Amount]: z.number(),
    [ExternalPaymentFormField.Type]: z.nativeEnum(ExternalPaymentType).or(z.string().min(1)),
    [ExternalPaymentFormField.ExternalIdentifier]: z.string().nullish(),
});

export type ExternalPaymentFormValues = z.infer<typeof externalPaymentFormSchema>;
